import React from 'react';
import { UnifiedPlayerController } from '../types';

export const useControllerState = () => {
    const [controller, setController] = React.useState<
        UnifiedPlayerController | undefined
    >(undefined);
    const [, forceUpdate] = React.useReducer((x) => (x + 1) % 2, 0);

    React.useEffect(() => {
        if (!controller) return;
        const unsubscribe = controller.subscribe(() => forceUpdate());
        return () => unsubscribe();
    }, [controller]);

    return {
        controller,
        setController,
    };
};
